import { App } from 'antd';
import { Suspense, lazy, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isUploadTabLocation } from '@/domain/video-upload';
import { useVideoUploadStore, type VideoUploadStatus } from './video-upload-store';

// Thanh tiến độ chỉ tải về khi thật sự có video đang lên — đa số lượt mở app không đụng tới Đăng video.
const VideoUploadDockPanel = lazy(() =>
  import('./VideoUploadDockPanel').then((m) => ({ default: m.VideoUploadDockPanel })),
);

/**
 * TIẾN ĐỘ TẢI VIDEO sống NGOÀI màn «Đăng video» (07/10/2026, chủ dự án: «Tôi đang tải video nhưng chuyển sang
 * chức năng khác … tôi vẫn muốn bạn code cho tải tiếp và giữ % để tôi theo dõi đến hoàn thành»). Hàng đợi vốn
 * đã chạy nền (`video-upload-store`); phần này cho người dùng THẤY nó từ mọi mục: thanh dính đáy khung ứng
 * dụng với phần trăm, tốc độ, còn bao lâu, và báo khi từng video lên xong hay hỏng. Ở ngay tab Tải lên thì bảng
 * đã hiện tiến độ nên thanh ẩn đi.
 */
export function VideoUploadDock() {
  const { message } = App.useApp();
  const location = useLocation();
  const items = useVideoUploadStore((state) => state.items);
  const active = items.some((item) => item.status === 'uploading' || item.status === 'finishing');
  const seen = useRef(new Map<number, VideoUploadStatus>());

  // Video lên xong / hỏng thì báo dù người dùng đang đứng ở mục nào.
  useEffect(() => {
    const known = seen.current;
    for (const item of items) {
      const before = known.get(item.id);
      if (before !== undefined && before !== item.status) {
        if (item.status === 'done')
          void message.success(`Đã tải xong «${item.name}» lên YouTube`, 6);
        else if (item.status === 'failed') void message.error(`«${item.name}»: ${item.error}`, 10);
      }
      known.set(item.id, item.status);
    }
    for (const id of [...known.keys()]) {
      if (!items.some((item) => item.id === id)) known.delete(id);
    }
  }, [items, message]);

  if (!active || isUploadTabLocation(location.pathname, location.search)) return null;
  return (
    <Suspense fallback={null}>
      <VideoUploadDockPanel />
    </Suspense>
  );
}
